/* 
  data: 传入进来的数据源
  output: 输出给业务端的html结构代码
  函数名命名规则：业务系统——功能——模块
*/
export const LV3_Bill_List = (data: any, data1: any): any => {
  console.log(data)
  const lineHeight = 27
  const maxLine = 35
  let currLine = 13
  let totalNum = 0
  let tbodyHtml = ''
  let beyondLine = 54
  data.forEach((table: any) => {
    totalNum += table.orderAmount
    currLine += table.maxSize
    tbodyHtml += `<tr><td align='center'>${table.orderNo}</td><td align='center'>`
    table.reportNameList.forEach((v2: any) => {
      tbodyHtml += `<p class='orderNo'>${v2}</p>`
    })
    tbodyHtml += `</td><td align='center'>${table.referenceInfo}</td>
      <td align='center'>${table.orderAmount.toFixed(2)}</td>
      <td align='center'><p class='userName'>${table.userName
      }</p></td></tr>`
  })
  // 银行信息换页
  if (maxLine - currLine <= 13) {
    beyondLine = lineHeight * (maxLine - currLine)
  } else {
    if (currLine % maxLine <= 13) {
      beyondLine = lineHeight * (currLine % maxLine)
    }
  }
  console.log(currLine, beyondLine)
  const output = `
      <html>
      <head>
        <style type="text/css">
          * {
            font-family: SimSun; 
            color: #000; 
            margin: 0; 
            font-size: 12px; 
            word-wrap: break-word; 
            word-break: break-all;
            padding: 0; 
            margin: 0;
            line-hieight: 27px;
          }
          .hide { color:#fff; }
          table {
            margin-bottom: 20px;
          }
          table td {
            line-height: 27px;
            padding: 0 5px;
          }
            table td, table th {
            line-height: 27px;
            padding: 0 5px;
          }
          table.border {
            border-top: 1px solid #ddd;
            border-right: 1px solid #ddd;
          }
          table.border th,  table.border td {
            border-bottom: 1px solid #ddd;
            border-left: 1px solid #ddd;
          }
          .template-html-table-box {
            position: relative;
          }
          .template-html-table-box img {
            position: absolute;
            bottom: -75px;
            right: 20%;
            width: 154px;
          }
          .template-html-box-wrap div {
            line-height: 27px;
          }
        </style>
      </head>
      <body>
        <div class="template-html">
          <table border="0" width='100%' cellspacing='0' cellpadding='0'>
            <tr>
              <td>
                <img src="http://cnapp.sgs.net/sgsLogin/images/sgs-logo-@2x.png" style='height: 54px;' />
              </td>
            </tr>
            <tr>
              <td>
                <b>SGS-CSTC Standards Technical services Co,Ltd</b>
              </td>
            </tr>
              <tr>
              <td><p class='hide'>占位</p></td>
            </tr>
            <tr>
              <td align='center'>
                  <b>Monthly Report for Client</b>
              </td>
            </tr>
            <tr>
              <td align='center'>
                (Date From:${data1.billStartDate} To:${data1.billEndDate})
              </td>
            </tr>
            <tr>
              <td>
                Client：<b>${data1.invoiceTitle}</b>
              </td>
            </tr>
            <tr>
              <td>
                Customer Number：${data1.customerNumber}
              </td>
            </tr>
            <tr>
              <td>
                Contact：${data1.userList.map((v: any) => {
    return v.userName + ' '
  })}
              </td>
            </tr>
            <tr>
              <td>
                Tel： ${data1.userList.map((v: any) => {
    return v.userPhone + ' '
  })}
              </td>
            </tr>
            <tr>
              <td><p class='hide'>占位</p></td>
            </tr>
          </table> 
          <div class="template-html-table-box">
            <table border="0"  width='100%' cellspacing='0' cellpadding='0' class='border'>
              <thead>
                <tr>
                  <th align='center' width='26%'>TIC No.</th>
                  <th align='center' width='27%'>报告号</th>
                  <th align='center' width='27%'>Reference No.</th>
                  <th align='center' width='11%'>RMB</th>
                  <th align='center' width='9%'>Remark</th>
                </tr> 
              </thead>
              <tbody>
                ${tbodyHtml}
              </tbody>
              <tfoot>
                <tr>
                  <th></th>
                  <th></th>
                  <th align="center">TOTAL:</th>
                  <th align="right">${totalNum.toFixed(2)}</th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
            <img src="https://publicfiles.sgsonline.com.cn/TIC/2022/01/zhang_1642735641455.png" alt="" />
          </div>
          <div class="template-html-box-wrap">
              <div class="bank-info" style='padding-top: ${beyondLine}px;'>
                  <div>Please use the following Bank Account for payment /请将汇款汇入以下银行账号：</div>
                  <div>账户名称：通标标准技术服务有限公司杭州分公司</div>
                  <div>收款账号：1760312203</div>
                  <div>开户银行：花旗银行（中国）有限公司杭州分行</div>
                  <div>开户行号：531331000015</div>
                  <div>开户银行地址：中国杭州市庆春路118号嘉德广场十三楼A,B,G单元</div>
              </div>
              <div class="tips" style='padding-top: 27px;'>
                  <div>备注:请贵司收到报表核对无误后按合同指定日期内付款。</div>
                  <div><b>并将付款凭证发至我司邮箱sgsonline.vat@sgs.com 请在邮件中注明我司的税务发票号。</b></div>
                  <div>如有疑问请与我司Vera Ding 联系，TEL:0571-89829620 EMAIL:sgsonline.vat@sgs.com 谢谢配合!</div>
              </div>
          </div>
        </div>
      </body>
      </html>`;

  return new Promise((resolve) => {
    resolve(output)
  })
}